export function getAllTasks(state) {
  return state.allTasksNEvents
}

export function getOnlyTasks(state) {
  return state.tasks
}

export function getTasksPerDate(state) {
  return state.taskPerDate;
}

export function getOnlyEvents(state) {
  return state.events
}

export function getTodayTasks(state) {
  return state.todayTasks
}

export function getPendingTasks(state) {
  return state.pendingTasks
}

export function getPendingTasksNoComplete(state) {
  let response = []
  state.pendingTasks.forEach(element => {
    if (element.state == '3' || element.state == '1') {
      response.push(element)
    }
  });
  return response
}

export function error(state) {
  return state.error
}

export function errorMessage(state) {
  return state.errorMessage
}

export function getClasses(state) {
  //console.log("classes", state.Classes)
  let response = []
  state.Classes.forEach(element => {
    response.push({ value: element.id, text: element.name, state: element.state, color: element.color })
  });
  return response
}

export function getActiveClasses(state) {
  let response = []
  state.Classes.forEach(element => {
    if (element.state) {
      response.push({ value: element.id, text: element.name, state: element.state })
    }
  });
  return response
}

export function getRepeatOptions(state) {
  return state.RepeatOptions
}

export function getTasksTypes(state) {
  let response = []
  state.Types.Tasks.forEach(element => {
    response.push({ value: element.id, text: element.name })
  })
  return response
}

export function getNotificationsType(state) {
  return state.notificationsTypes
}

export function getEventsTypes(state) {
  let response = []
  state.Types.Events.forEach(element => {
    response.push({ value: element.id, text: element.name })
  })
  return response
}

export function getTaskId(state) {
  return id => {
    let elementToReturn = {}
    state.allTasksNEvents.forEach(element => {
      if (element.id == id) {
        elementToReturn = element
      }
    })
    return elementToReturn
  }
}

export function getProjects(state) {
  return state.projects
}

export function getProjectTaks(state) {
  return id => {
    const project = state.projects.find(project => `${project.id}` === `${id}`);
    return project.tasks || []
  }  
}

export function getProjectNames(state) {
  let response = []
  state.projects.forEach(element => {
    response.push({ value: element.id, text: element.title })
  })
  return response
}

export function getProject(state) {
  return id => {
    const project = state.projects.find(project => `${project.id}` === `${id}`);
    return project || {}
  }  
}
